<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<mat-toolbar class="top-bar">
  <mat-toolbar-row class="nav-row d-flex flex-row justify-content-start align-items-center">
    <span class="text flex-grow-0">Caster</span>
    <div class="flex-fill">
      <div
        class="text d-flex flex-row justify-content-end align-items-center gap-2"
        id="toolbar-navigation"
      ></div>
    </div>
  </mat-toolbar-row>
  <mat-toolbar-row
    class="cwd-action-row d-flex flex-row justify-content-start align-items-center"
  >
    <div style="margin-left: 15%">
      <div
        id="toolbar-action"
        class="d-flex flex-row justify-content-start align-items-center gap-2"
      ></div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
